import React, { useState, useEffect } from 'react';
import { useTranslate } from '../lib/i18n';

export default function ThinkingIndicator() {
  const t = useTranslate();
  const [label, setLabel] = useState(() => t('common.labels.thinking'));

  const delayMs = 3000;

  useEffect(() => {
    const id = setTimeout(() => {
      setLabel(t('common.labels.writing'));
    }, delayMs);
    return () => clearTimeout(id);
  }, [t, delayMs]);

  const shimmerStyle = {
    backgroundImage: 'linear-gradient(90deg, #9ca3af 25%, #ffffff 50%, #9ca3af 75%)',
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    animation: 'shimmer 2s ease-in-out infinite',
  };

  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
      <div role="status" aria-live="polite" className={`flex items-center`}>
        <span className={`text-sm font-medium text-muted-foreground`} style={shimmerStyle}>
          {label}
        </span>
      </div>
    </>
  );
}
